module.exports = __webpack_public_path__ + "static/t_325_717-2eab1e385e114fab4d28087a52e3efd2.png";